/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Goetheschule1Inputs */

const en__field_enum_goetheschule1 = /** @type {(inputs: _Field_Enum_Goetheschule1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu-Isenburg`)
};

const de__field_enum_goetheschule1 = /** @type {(inputs: _Field_Enum_Goetheschule1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goetheschule`)
};

/**
* | output |
* | --- |
* | "Neu-Isenburg" |
*
* @param {_Field_Enum_Goetheschule1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_goetheschule1 = /** @type {((inputs?: _Field_Enum_Goetheschule1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Goetheschule1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_goetheschule1(inputs)
	return de__field_enum_goetheschule1(inputs)
});
export { _field_enum_goetheschule1 as "_field_enum_Goetheschule" }